import { criarRepositorio } from './createRepository';

export const repositorioFazenda = criarRepositorio('fazenda');
export const repositorioTalhao = criarRepositorio('talhao');
export const repositorioMaquina = criarRepositorio('maquina');
export const repositorioFuncionario = criarRepositorio('funcionario');
export const repositorioTipoMaquina = criarRepositorio('tipo_maquina');
export const repositorioFabricanteMaquina = criarRepositorio('fabricante_maquina');
